import { render, staticRenderFns } from "./PopsSubFolderInfra.vue?vue&type=template&id=bf58606a&scoped=true"
import script from "./PopsSubFolderInfra.vue?vue&type=script&lang=js"
export * from "./PopsSubFolderInfra.vue?vue&type=script&lang=js"
import style0 from "./PopsSubFolderInfra.vue?vue&type=style&index=0&id=bf58606a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf58606a",
  null
  
)

export default component.exports